import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/dropdown-menu';
import { Calendar, ChevronDown, Grid } from 'lucide-react';

export type CalendarView = 'dayGridMonth' | 'timeGridWeek' | 'timeGridDay';

interface ViewToggleProps {
  currentView: CalendarView;
  onViewChange: (view: CalendarView) => void;
}

const viewOptions: { value: CalendarView; label: string; icon: React.ReactNode }[] = [
  {
    value: 'dayGridMonth',
    label: 'Month',
    icon: <Grid size={16} />,
  },
  {
    value: 'timeGridWeek',
    label: 'Week',
    icon: <Calendar size={16} />,
  },
  {
    value: 'timeGridDay',
    label: 'Day',
    icon: <Calendar size={16} />,
  },
];

export function ViewToggle({ currentView, onViewChange }: ViewToggleProps) {
  const currentOption = viewOptions.find((opt) => opt.value === currentView);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          icon={{ src: currentOption?.icon }}
          className="min-w-[120px] justify-between"
        >
          {currentOption?.label}
          <ChevronDown size={16} className="ml-2 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {viewOptions.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onClick={() => onViewChange(option.value)}
            className="cursor-pointer"
          >
            <span className="mr-2">{option.icon}</span>
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
